import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/theme-provider";
import SiteLayout from "@/components/layout/SiteLayout";
import Landing from "@/pages/Landing";
import BSA from "@/pages/BSA";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Signup from "@/pages/Signup";

function App() {
    return (
        <div className="App">
            <ThemeProvider>
                <BrowserRouter>
                    <SiteLayout>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/products/bsa" element={<BSA />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/signup" element={<Signup />} />
                        </Routes>
                    </SiteLayout>
                    <Toaster richColors position="bottom-right" />
                </BrowserRouter>
            </ThemeProvider>
        </div>
    );
}

export default App;
